// ============================================================
//  src/storage/storage.js — Selector de provider de storage
// ============================================================

import userDriveProvider    from './user-drive-provider.js';
import managedDriveProvider from './managed-drive-provider.js';

const PROVIDERS = {
    'user_drive':    userDriveProvider,
    'managed_drive': managedDriveProvider,
};

/**
 * Retorna el provider correspondiente al storageType.
 * @param {'user_drive'|'managed_drive'} storageType
 */
export function getProvider(storageType = 'user_drive') {
    const provider = PROVIDERS[storageType];

    if (!provider) {
        throw new Error(`[Storage] Provider desconocido: ${storageType}`);
    }

    return provider;
}
